import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=cbeb6660&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbeb6660",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbeb6660')) {
      api.createRecord('cbeb6660', component.options)
    } else {
      api.reload('cbeb6660', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=cbeb6660&scoped=true&", function () {
      api.rerender('cbeb6660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/Login.vue"
export default component.exports